module.exports = __webpack_public_path__ + "static/media/stop.386ec1ea.svg";